/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Properties available for sorting charger asset links.
 */
export var LinkPropertiesForSorting;
(function (LinkPropertiesForSorting) {
    LinkPropertiesForSorting["NAME"] = "name";
    LinkPropertiesForSorting["STATUS"] = "status";
    LinkPropertiesForSorting["EXPIRY_DATE"] = "expiryDate";
    LinkPropertiesForSorting["FEATURES"] = "features";
    LinkPropertiesForSorting["NUMBER_OF_VIEWS"] = "NumberOfViews";
})(LinkPropertiesForSorting || (LinkPropertiesForSorting = {}));
